import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const AppDataContext = createContext(null);
export const AppDataProvider = ({ adapter, children }) => (_jsx(AppDataContext.Provider, { value: adapter, children: children }));
export const useAppData = () => {
    const adapter = useContext(AppDataContext);
    if (!adapter) {
        throw new Error('useAppData must be used within a AppDataProvider');
    }
    return adapter;
};
//# sourceMappingURL=app-data-context.js.map